<template>
  <div>
    <div class="d-flex align-items-center">
      <a-icon style="font-size: 20px; cursor: pointer;" class="mr-2" type="arrow-left" @click="$router.back()" />
      <h1 class="h3 mb-0">
        {{ $t('adjustment.detail') }}: {{ $route.query.number_adjustment }}
      </h1>
    </div>
    <div class="mt-4">
      <a-table
        class="gr-list"
        :data-source="products"
        :row-key="record => record.catalog_id"
        :columns="columns"
        :loading="isLoading"
        :scroll="scroll"
        :pagination="{
          showTotal: (total, range) => $t('utils.pagination_show_total', { perpage: `${range[0]} - ${range[1]}`, total }),
          total: total_row,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
          locale: { items_per_page: $t('utils.items_per_page') }
        }"
      >
        <template slot="numberColumn" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import { getDetailStockAdjustment } from '@/api/inventory'



export default {
  data: function () {
    return {
      screenHeight: ((screen.height - 900) * 0.5) + (screen.height * 0.5),
      total_row: 0,
      isLoading: false,
      products: [],
    }
  },
  computed: {
    columns() {
      return [
        {
          title: 'No',
          dataIndex: 'number',
          key: 'number',
          width: 100,
        },
        {
          title: this.$t('productAvailability.title'),
          dataIndex: 'catalog_title',
          key: 'catalog_title',
        },
        {
          title: this.$t('productAvailability.sku'),
          dataIndex: 'sku',
          key: 'sku',
        },
        {
          title: this.$t('utils.quantity'),
          dataIndex: 'quantity',
          key: 'quantity',
        },
        {
          title: 'UOM',
          dataIndex: 'unit',
          key: 'unit',
        },
      ]
    },
    businessId() {
      if (this.$store.state.user.restriction_base === 'Warehouse') {
        return Object.keys(this.$store.getters['user/businessListObjectByKey'])[0] || ''
      }
      return this.$route.query.business_id || ''
    },
    scroll() {
      let yValue = 360
      if (this.screenHeight > 450) {
        yValue = this.screenHeight
      }
      
      return {
        y: yValue,
        x: 1000,
      }
    },
    tHeight() {
      if (!this.products.length) {
        return '0px'
      }
      
      if (this.screenHeight > 450) {
        return `${this.screenHeight}px`
      }
      
      return '450px'
    },
  },
  watch: {
    businessId() {
      this.getDetailGR()
    },
  },
  created() {
    this.getDetailGR()
  },
  methods: {
    async getDetailGR() {
      this.isLoading = true
      try {
        const { data: response } = await getDetailStockAdjustment({
          business_id: this.businessId,
          id: this.$route.params.id,
        })
        this.products = response?.map((item, index) => ({
          ...item,
          number: item?.number || index + 1,
        })) || []
        this.total_row = response?.length || 0
      } catch (err) {
        this.total_row = 0
        this.products = []
        console.error(err)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss">
.select-antd-default.ant-select-lg {
  width: 100%;

  .ant-select-selection__rendered {
    line-height: 38px !important;
  }
}

.gr-list div.ant-table-body {
  min-height: v-bind(tHeight);
}
</style>